import Vue from "vue"
import Vuex from "vuex"


import loading from "@/store/modules/loading"
import manager from "@/store/modules/manager"
import auth from "@/store/modules/auth"
import catalogue from "@/store/modules/catalogue"
import procedures from "@/store/modules/procedures"
import vaccinations from "@/store/modules/vaccinations"
import lab from "@/store/modules/lab"
import health from "@/store/modules/health"
import prescriptions from "@/store/modules/prescriptions"
import letters from "@/store/modules/letters"
import decursus from "@/store/modules/decursus"
import referrals from "@/store/modules/referrals"
import messaging from "@/store/modules/messaging"
import patients from "@/store/modules/patients"
import patientForms from "@/store/modules/patientForms"
import insurances from "@/store/modules/insurances"
import episodes from "@/store/modules/episodes"
import planning from "@/store/modules/planning"
import schedule from "@/store/modules/schedule"
import revisions from "@/store/modules/revisions"
import viewcreator from "@/store/modules/viewcreator"
import interchange from "@/store/modules/interchange"
import keyboardshortcuts from "@/store/modules/keyboardshortcuts"

Vue.use(Vuex)

export default new Vuex.Store({
	strict: true,
	modules: {
		loading,
		manager,
		auth,
		catalogue,
		procedures,
		vaccinations,
		lab,
		health,
		prescriptions,
		letters,
		decursus,
		referrals,
		messaging,
		patients,
		patientForms,
		insurances,
		episodes,
		planning,
		schedule,
		keyboardshortcuts,
		revisions,
		viewcreator,
		interchange
	},
	actions: {
		resetAll({ dispatch }) {
			// console.log('reset all')
			dispatch('planning/resetState')
			dispatch('patients/resetState')
			dispatch('patientForms/resetState')
			dispatch('decursus/resetState')
			dispatch('episodes/resetState')
			dispatch('insurances/resetState')
			dispatch('lab/resetState')
			dispatch('prescriptions/resetState')
			dispatch('procedures/resetState')
			dispatch('referrals/resetState')
			dispatch('revisions/resetState')
			dispatch('vaccinations/resetState')
			dispatch('manager/resetState')
	    }
	}
})
